import axios from "axios";
import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";

class UserServices {
  getAll() {
    return axios.get(ApiUrl + "user", header());
  }

  getOne(id) {
    return axios.get(ApiUrl + `user/${id}`, header());
  }

  create(data) {
    return axios.post(ApiUrl + "user", data, header());
  }

  createMany(data) {
    return axios.post(ApiUrl + "user/insert/many/client", data, header());
  }

  update(id, data) {
    return axios.put(ApiUrl + `user/${id}`, data, header());
  }

  delete(id) {
    return axios.delete(ApiUrl + `user/${id}`, header());
  }

  updatePassword(id, data) {
    return axios.patch(ApiUrl + `user/updateMyPassword/${id}`, data, header());
  }

  generateFile(data) {
    return axios.post(ApiUrl + `user/generatefile`, data, header());
  }

  updateProfilePicture(id, file) {
    return axios.patch(
      ApiUrl + `user/update/profil/${id}`,
      file,
      header("image")
    );
  }
}


export default new UserServices();
